import * as c from '../constants/ApprovalRequestConstants'

export const setSortColumn = column => dispatch =>
  dispatch({ type: c.SET_APPROVAL_REQUEST_TABLE_SORT_COLUMN, payload: column })

export const setSortDir = dir => dispatch => {
  dispatch({ type: c.SET_APPROVAL_REQUEST_TABLE_SORT_DIR, payload: dir })
}

export const setSortColumnAndDirection =
  ({ column, direction }) =>
  dispatch => {
    dispatch({
      type: c.SET_APPROVAL_REQUEST_TABLE_SORT_COLUMN_AND_DIR,
      payload: { column, direction },
    })
  }
